import React, {useEffect, useState} from 'react';
import {client, urlFor} from '../../../lib/sanityClient';
import {ALL_POSTS_QUERY, RECENT_POSTS_QUERY} from '../../../lib/sanityQueries';

const FALLBACK_IMGS = [
  '/light/assets/imgs/spob/spob-1.jpg',
  '/light/assets/imgs/spob/spob-2.jpg',
  '/light/assets/imgs/spob/spob-3.jpg',
  '/light/assets/imgs/spob/spob-4.jpg',
  '/light/assets/imgs/spob/spob-5.jpg',
  '/light/assets/imgs/spob/spob-6.jpg',
];

function formatDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric',
  });
}

function Blogs() {
  const [posts, setPosts] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      client.fetch(ALL_POSTS_QUERY),
      client.fetch(RECENT_POSTS_QUERY),
    ]).then(([allPosts, recent]) => {
      setPosts(allPosts);
      setRecentPosts(recent);
      setLoading(false);
    }).catch(err => {
      console.error('Sanity fetch error:', err);
      setLoading(false);
    });
  }, []);

  return (
    <section className="blog-main section-padding">
      <div className="container">
        <div className="row lg-marg justify-content-around">

          {/* Blog Posts Column */}
          <div className="col-lg-7">
            <div className="md-mb80">
              {loading && (
                <div className="text-center py-5">
                  <p className="opacity-7">Loading posts...</p>
                </div>
              )}
              {!loading && posts.length === 0 && (
                <div className="text-center py-5">
                  <p className="opacity-7">
                    No posts yet. Add content in the Sanity Studio.
                  </p>
                </div>
              )}
              {posts.map((post, i) => (
                <div
                  className={`item ${i < posts.length - 1 ? 'mb-50' : ''}`}
                  key={post._id}
                >
                  <div className="img">
                    <img
                      src={
                        post.mainImage
                          ? urlFor(post.mainImage).width(800).url()
                          : FALLBACK_IMGS[i % FALLBACK_IMGS.length]
                      }
                      alt={post.mainImage?.alt || post.title}
                    />
                  </div>
                  <div className="content main-bg">
                    <div className="d-flex align-items-center mb-15">
                      <div className="post-date">{formatDate(post.publishedAt)}</div>
                      {post.categories && post.categories.length > 0 && (
                        <div className="tag ml-20 opacity-7 fz-13">
                          {post.categories[0].title}
                        </div>
                      )}
                    </div>
                    <h4 className="mb-15">
                      <a href={`/light/blog/${post.slug.current}`}>{post.title}</a>
                    </h4>
                    {post.excerpt && <p>{post.excerpt}</p>}
                    <a
                      href={`/light/blog/${post.slug.current}`}
                      className="d-flex align-items-center mt-40"
                    >
                      <span className="text mr-15">Read More</span>
                      <span className="ti-arrow-top-right"></span>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Sidebar Column */}
          <div className="col-lg-4">
            <div className="sidebar">
              <div className="search-box">
                <input type="text" name="search-post" placeholder="Search" readOnly />
                <span className="icon pe-7s-search"></span>
              </div>

              {recentPosts.length > 0 && (
                <div className="widget last-post-thum">
                  <h6 className="title-widget">Latest Posts</h6>
                  {recentPosts.map((rp, i) => (
                    <div className="item d-flex align-items-center" key={rp._id}>
                      <div>
                        <div className="img">
                          <a href={`/light/blog/${rp.slug.current}`}>
                            <img
                              src={
                                rp.mainImage
                                  ? urlFor(rp.mainImage).width(120).height(100).url()
                                  : FALLBACK_IMGS[i % FALLBACK_IMGS.length]
                              }
                              alt={rp.title}
                            />
                            <span className="date">
                              <span>
                                {new Date(rp.publishedAt).getDate()} /{' '}
                                <br />
                                {new Date(rp.publishedAt).toLocaleString('en', {month: 'short'})}
                              </span>
                            </span>
                          </a>
                        </div>
                      </div>
                      <div className="cont">
                        <h6>
                          <a href={`/light/blog/${rp.slug.current}`}>{rp.title}</a>
                        </h6>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div className="widget tags">
                <h6 className="title-widget">Tags</h6>
                <div>
                  <a href="/light/blog-classic">Health</a>
                  <a href="/light/blog-classic">Education</a>
                  <a href="/light/blog-classic">Culture</a>
                  <a href="/light/blog-classic">Environment</a>
                  <a href="/light/blog-classic">Outreach</a>
                  <a href="/light/blog-classic">Youth</a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Blogs;
